import { Component } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { LicenseService } from 'common/util/module'
import { ParametersService } from 'main/services/parameters.service'
import { IdentityService } from 'main/services/identity.service'
import { TaskInfo } from 'elements-sdk'
import { TasksService, TaskState } from '../services/tasks.service'

@Component({
  selector: 'tasks-popup',
  templateUrl: './tasksPopup.component.pug',
  styleUrls: ['./tasksPopup.component.scss'],
})
export class TasksPopupComponent {
  updatesPaused = false
  TaskState = TaskState
  pendingCount = 0
  runningTasks: TaskInfo[] = []
  optionsExpanded = false

  tasksPlural = `{
    count, plural,
    =0{No recent tasks}
    one{One task}
    other{{count} tasks}
  }`

  moreTasksPlural = `{
    count, plural,
    one{One more task}
    other{{count} more tasks}
  }`

  constructor (
    public tasks: TasksService,
    public license: LicenseService,
    public identity: IdentityService,
    public parameters: ParametersService,
    private translate: TranslateService,
  ) { }

  ngOnInit () {
    this.updateLists()
    this.tasks.tasksUpdated$.subscribe(() => {
      if (!this.updatesPaused) {
        this.updateLists()
      }
    })
  }

  totalTasks () {
    return this.runningTasks.length + this.pendingCount
  }

  updateLists () {
    this.runningTasks = this.tasks.tasks.filter(task =>
      [TaskState.RUNNING, TaskState.ABORTING].includes(task.state as any))
    this.pendingCount = this.tasks.pendingCount
  }

  async killTask (task) {
    await this.tasks.kill(task)
    this.updateLists()
  }

  async abortTask (task) {
    await this.tasks.abort(task)
    this.updateLists()
  }

  pauseUpdates () {
    this.updatesPaused = true
  }

  resumeUpdates () {
    this.updatesPaused = false
    this.updateLists()
  }

  trackById = t => t.id
}
